import { render } from "./TodayPatients.vue?vue&type=template&id=91a3b774&scoped=true"
import script from "./TodayPatients.vue?vue&type=script&lang=js"
export * from "./TodayPatients.vue?vue&type=script&lang=js"

import "./TodayPatients.vue?vue&type=style&index=0&id=91a3b774&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a3b774"]])

export default __exports__